import React, { Component, ReactNode } from "react"
import { Footer } from "./Footer"
import { Header } from "./Header"
import { LanguageSwitcher } from "./LanguageSwitcher"

export interface LayoutProps {
  lang: string
  langSwitcher: boolean
  children: ReactNode
}

// layout that contains children
export class Layout extends Component<LayoutProps> {
  render() {
    return (
      <div className="w-screen overflow-hidden">
        <Header />
        {this.props.langSwitcher !== false && (
          <LanguageSwitcher currentLanguage={this.props.lang} />
        )}
        <div className="flex flex-col items-center md:p-12 p-6 gap-8">
          {this.props.children}
        </div>
        <Footer lang={this.props.lang} />
      </div>
    )
  }
}
